<template>
  <v-container fluid class="pa-0 h-100 d-flex flex-column">
    <v-row no-gutters class="d-flex flex-column h-100">
      <v-col class="left-col flex-grow-0">
        <header class="d-flex justify-space-between mb-4">
          <h1 class="text-h6 text-md-h5 font-weight-bold">Facturación</h1>
          <v-btn text color="blue darken-2"
            ><v-icon>file_download</v-icon>descargar en pdf</v-btn
          >
        </header>
      </v-col>

      <v-col class="left-col">
        <main class="h-100 d-flex flex-column" style="gap: 1.5rem">
          <div
            v-if="visibleRejectedBills.length > 0"
            class="d-flex flex-column"
            style="gap: 1rem"
          >
            <BillErrorAlert
              v-for="bill of visibleRejectedBills"
              :key="bill.id"
              :bill="bill"
              @hidden="onBillAlertHidden"
            />
          </div>

          <BillAlert />

          <div
            v-if="isBillsLoading"
            class="d-flex flex-column justify-center align-center h-100"
          >
            <Loader text="Cargando facturas" />
          </div>

          <div v-else class="d-flex flex-column" style="gap: 1.5rem">
            <section class="d-flex flex-column" style="gap: 1rem">
              <BillCard
                v-for="bill of visibleBills"
                :key="bill.id"
                :bill="bill"
              />
            </section>

            <v-btn
              v-if="bills?.length > maxVisible"
              style="align-self: center"
              text
              color="blue darken-2"
              @click="toggleVisible"
            >
              {{ showAll ? "Ver menos" : "Ver más" }}
            </v-btn>
          </div>
        </main>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BillCard from "../components/BillCard.vue";
import BillAlert from "../components/BillAlert.vue";
import Loader from "../components/Loader.vue";
import BillErrorAlert from "../components/BillErrorAlert.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "BillView",
  components: { BillCard, BillAlert, Loader, BillErrorAlert },
  data: () => ({
    showAll: false,
    maxVisible: 5,
    alertVisibilityTick: 0,
  }),
  computed: {
    ...mapState("invoice", {
      bills: (state) => state.invoices,
      isBillsLoading: (state) => state.isBillsLoading,
    }),

    visibleBills() {
      return this.showAll ? this.bills : this.bills.slice(0, this.maxVisible);
    },

    rejectedBills() {
      return (this.bills || []).filter((bill) => bill.have_transaction_rejected);
    },

    visibleRejectedBills() {
      void this.alertVisibilityTick;

      return this.rejectedBills.filter((bill) => {
        const storedValue = localStorage.getItem(`hidden-alert-bill-${bill.id}`);
        return storedValue !== "hidden";
      });
    },
  },
  created() {
    this.getBills();
  },
  mounted() {
    this.$store.commit("set_app_title", "Facturación");
  },
  methods: {
    ...mapActions("invoice", ["getBills"]),

    onBillAlertHidden() {
      this.alertVisibilityTick += 1;
    },

    toggleVisible() {
      this.showAll = !this.showAll;
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .left-col {
    width: 100%;
  }
}

@media (min-width: 960px) {
  .left-col {
    width: 65%;
  }
}
</style>
